import { FC } from "react";
import { SanityPrimoTicketsCard } from "../../graphql-types";
import { cn } from "../lib/helpers";
import PortableText from "./portableText";
import * as styles from "./TicketsCardPrimo.module.scss";
import { bodyTextStyle } from "./typography.module.scss";

export interface TicketsCardPrimoProps extends SanityPrimoTicketsCard {
  className?: string;
}

const TicketsCard: FC<TicketsCardPrimoProps> = ({
  title,
  subtitle,
  price,
  detailsOne,
  _rawDetailsOne,
  detailsTwo,
  _rawDetailsTwo,
  className,
}) => {
  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.heading}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
        <div className={styles.price}>{price}</div>
      </div>
      <div className={cn(bodyTextStyle, styles.details, styles.detailsOne)}>
        <PortableText blocks={_rawDetailsOne || detailsOne} />
      </div>
      <div className={cn(bodyTextStyle, styles.details)}>
        <PortableText blocks={_rawDetailsTwo || detailsTwo} />
      </div>
    </div>
  );
};

export default TicketsCard;
